module.exports = __webpack_public_path__ + "img/partner.27348849.jpg";